<template>
  <div class="rn-pricing">
    <!-- Pro carries 21 features to Premium's 9, so equal thirds squeeze it and
         the grid stretches every card to match. Give Pro the extra width, and
         hold the stack until lg so tablets get full-width cards. -->
    <div class="grid grid-cols-1 lg:grid-cols-[1fr_1fr_1.6fr] gap-[3px] items-start">
      <!-- Free Trial -->
      <div class="card">
        <div class="card-header">
          <picture class="contents">
            <source srcset="/images/Subscriptions/icon-basic-6f213f384d884a322256104563db3c0d.webp" type="image/webp" />
            <img
            class="card-icon"
            src="/images/Subscriptions/icon-basic-6f213f384d884a322256104563db3c0d.png"
            :alt="tt.trialAlt"
            width="256"
            height="256"
            loading="lazy"
            decoding="async"
            />
          </picture>
          <h3>{{ tt.trialH3 }}</h3>
          <div class="price"><span class="cur">$</span>0<span class="usd">USD</span></div>
          <div class="duration">{{ tt.trialDuration }}</div>
          <div class="note">{{ tt.trialNote }}</div>
        </div>
        <ul class="perks">
          <li v-for="(p, i) in tt.trialPerks" :key="'th' + i" class="perks-heading">{{ p }}</li>
          <li v-for="(p, i) in tt.trialPerksMore" :key="'t' + i">{{ p }}</li>
        </ul>
      </div>

      <!-- Premium -->
      <div class="card">
        <div class="card-header">
          <picture class="contents">
            <source srcset="/images/Subscriptions/icon-premium-c7bae7f273ebe13c1b36090961c37814.webp" type="image/webp" />
            <img
            class="card-icon"
            src="/images/Subscriptions/icon-premium-c7bae7f273ebe13c1b36090961c37814.png"
            alt="Premium"
            width="256"
            height="256"
            loading="lazy"
            decoding="async"
            />
          </picture>
          <h3>Premium</h3>
          <div class="price"><span class="cur">$</span>49<span class="usd">USD</span></div>
          <div class="duration">{{ tt.premiumDuration }}</div>
          <div class="note">{{ tt.premiumNote }}</div>
        </div>
        <ul class="perks">
          <li class="perks-heading">{{ tt.premiumPerkHead }}</li>
          <li v-for="(p, i) in tt.premiumPerks" :key="'p' + i">{{ p }}</li>
        </ul>
      </div>

      <ProRallyCard :t="tt" />
    </div>
  </div>
</template>

<script>
import ProRallyCard from './ProRallyCard.vue';
import { DOWNLOAD_CONTENT } from '../content/downloadPage';

export default {
  name: 'PricingTable',
  components: { ProRallyCard },
  props: {
    // Pricing text for the page's language; English by default.
    t: { type: Object, default: null },
  },
  computed: {
    tt() {
      return this.t || DOWNLOAD_CONTENT.en.pricing;
    },
  },
};
</script>

<style scoped>
.rn-pricing {
  padding: 10px 0;
}

.card {
  background: #393a44;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.card-featured {
  background-color: #2c2d3b;
  border: 3px solid #ff0000;
}

.card-header {
  padding: 20px;
}

.card-icon {
  max-width: 110px;
  margin: 0 auto;
  padding-bottom: 16px;
}

.card-header h3 {
  font-family: 'Russo One', sans-serif;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0 0 3px #000;
  font-size: 21px;
  margin: 0;
}

.price {
  font-family: 'Russo One', sans-serif;
  color: #fff;
  text-shadow: 0 0 3px #000;
  font-size: 35px;
  line-height: 0.9em;
  margin-top: 10px;
}

.price .cur {
  font-size: 0.55em;
  vertical-align: top;
  margin-right: 2px;
}

.price .usd {
  font-size: 0.3em;
  color: #aeb0c5;
  vertical-align: top;
  margin-left: 2px;
  text-transform: uppercase;
}

.duration,
.note {
  font-family: 'Electrolize', sans-serif;
  text-transform: uppercase;
  text-shadow: 0 0 2px #000;
  font-size: 13px;
  line-height: 18px;
}

.duration {
  color: #aeb0c5;
  margin-bottom: 10px;
}

.note {
  color: #eee;
}

.perks {
  margin: 0;
  padding: 0;
  list-style: none;
}

.perks li {
  text-align: left;
  background-color: #484a61;
  padding: 10px 20px;
  color: #e5e5e5;
  font-size: 13px;
  line-height: 18px;
}

.perks li:nth-child(even) {
  background-color: #4c4f6e;
}

.perks-heading {
  font-weight: 700;
  color: #fff;
}

.perks-heading--block {
  text-align: left;
  background-color: #484a61;
  padding: 10px 20px;
  font-size: 13px;
  line-height: 18px;
}

/* Pro Rally two-column perks */
.perks-two-col .perk-link {
  color: inherit;
  text-decoration: none;
  display: block;
}

.perks-two-col .perk-link:hover,
.perks-two-col .perk-link:focus-visible {
  color: #fff;
  text-decoration: underline;
}

.perks-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.perks-two-col li:nth-child(even) {
  background-color: #484a61;
}

.perks-two-col li:nth-child(4n + 3),
.perks-two-col li:nth-child(4n) {
  background-color: #4c4f6e;
}

@media (max-width: 640px) {
  .perks-two-col {
    grid-template-columns: 1fr;
  }
}
</style>
